function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import classnames from 'classnames';
import { useLocation } from 'react-router-dom';
import { useLanguage } from "../../../../i18n";
import * as links from "../../../../constants/links";
import { Heading } from "../../../Typography";
import Grid from '../../Grid';
import { Link } from '../../../Common';
import { useHeaderContext } from '../HeaderContext';
import DesktopNav from './DesktopNav';
import Search from './Search';
import styles from './HeaderDesktop.scss';

var HeaderDesktop = function HeaderDesktop(_ref) {
  var onSubmitSearch = _ref.onSubmitSearch,
      _ref$navigation = _ref.navigation,
      navigation = _ref$navigation === void 0 ? [] : _ref$navigation,
      additionalContentSlot = _ref.additionalContentSlot,
      notifications = _ref.notifications,
      profileLinks = _ref.profileLinks,
      siteName = _ref.siteName,
      isSearchMode = _ref.isSearchMode,
      onClickLogin = _ref.onClickLogin,
      onClickLogout = _ref.onClickLogout,
      onSearchModeChange = _ref.onSearchModeChange,
      customHandleLangChange = _ref.customHandleLangChange;

  var _useLocation = useLocation(),
      pathname = _useLocation.pathname;

  var _useLanguage = useLanguage(),
      toLocalizedRoute = _useLanguage.toLocalizedRoute;

  var _useHeaderContext = useHeaderContext(),
      logoUrl = _useHeaderContext.logoUrl,
      isBeta = _useHeaderContext.isBeta;

  var isShowSearch = !!onSearchModeChange;

  var handleOpenSearch = function handleOpenSearch() {
    if (onSearchModeChange) {
      onSearchModeChange(true);
    }
  };

  var handleCloseSearch = function handleCloseSearch() {
    if (onSearchModeChange) {
      onSearchModeChange(false);
    }
  };

  var handleActiveNavLinkClick = function handleActiveNavLinkClick() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  var logoContent = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
    src: logoUrl,
    alt: "",
    className: styles.logo
  }), /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.siteName, _defineProperty({}, styles.beta, isBeta))
  }, /*#__PURE__*/React.createElement(Heading, {
    level: 2
  }, siteName)));
  var homeLinkActive = pathname === toLocalizedRoute(links.home);
  return /*#__PURE__*/React.createElement("header", {
    className: styles.header
  }, /*#__PURE__*/React.createElement(Grid.Container, {
    className: styles.headerContainer
  }, homeLinkActive ? /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: styles.logoWrap,
    onClick: handleActiveNavLinkClick
  }, logoContent) : /*#__PURE__*/React.createElement(Link, {
    to: links.home,
    className: styles.logoWrap
  }, logoContent), /*#__PURE__*/React.createElement(DesktopNav, {
    isOpened: !isSearchMode,
    onOpenSearch: isShowSearch ? handleOpenSearch : undefined,
    onClickLogin: onClickLogin,
    onClickLogout: onClickLogout,
    onActiveNavLinkClick: handleActiveNavLinkClick,
    navigation: navigation,
    additionalContentSlot: additionalContentSlot,
    notifications: notifications,
    profileLinks: profileLinks,
    customHandleLangChange: customHandleLangChange
  }), !!isShowSearch && !!onSubmitSearch && /*#__PURE__*/React.createElement(Search, {
    isOpened: isSearchMode,
    onClose: handleCloseSearch,
    onSubmit: onSubmitSearch
  })));
};

export default HeaderDesktop;